import { createRouter, createWebHistory } from "vue-router";
import { logout, hasAdminPermission } from '@/services/auth';
import { deberiaAnimar, taparPantalla, destaparPantalla, resetearCortina } from '@/composables/usePageTransition';
import { setPageTitle } from '@/utils/pageTitle';

/* Home eager: evita 2.ª ronda HTTP antes del h1 LCP en / */
import AppHome from "@/pages/Home.vue";
const ProductDetails = () => import(/* webpackChunkName: "product" */ "@/pages/ProductDetails.vue");
const ProductList = () => import(/* webpackChunkName: "product" */ "@/pages/ProductList.vue");
const ShoppingCart = () => import(/* webpackChunkName: "cart" */ "@/pages/ShoppingCart.vue");
const ProductForm = () => import(/* webpackChunkName: "admin" */ "@/components/admin/ProductForm.vue");
import { findPanelSection } from "@/data/panelSections";
const PanelLayout = () => import(/* webpackChunkName: "account" */ "@/components/panel/PanelLayout.vue");
const LoginForm = () => import(/* webpackChunkName: "auth" */ "@/pages/LoginForm.vue");
const RegisterForm = () => import(/* webpackChunkName: "auth" */ "@/pages/RegisterForm.vue");
const AdminProductList = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/AdminProductList.vue");
// const AdminOrderList = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/AdminOrderList.vue");
// const AdminOrderDetails = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/AdminOrderDetails.vue");

const AccountSettings = () => import(/* webpackChunkName: "account" */ "@/pages/AccountSettings.vue");
// const ActivityPage = () => import(/* webpackChunkName: "admin" */ "@/pages/ActivityPage.vue");
// const BankForm = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/BankForm.vue");
// const AdminBankList = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/AdminBankList.vue");
// const AdminWarrantyClaims = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/AdminWarrantyClaims.vue");
const UserList = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/UserList.vue");
const UserDetail = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/UserDetail.vue");
const GalleryPage = () => import(/* webpackChunkName: "content" */ "@/pages/GalleryPage.vue");
const BlogList = () => import(/* webpackChunkName: "blog" */ "@/pages/blog/BlogList.vue");
const BlogPostDetail = () => import(/* webpackChunkName: "blog" */ "@/pages/blog/BlogPostDetail.vue");
const AdminBlogList = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/AdminBlogList.vue");
const BlogPostEditor = () => import(/* webpackChunkName: "admin" */ "@/pages/admin/BlogPostEditor.vue");
const ContactForm = () => import(/* webpackChunkName: "support" */ "@/pages/ContactForm.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: AppHome,
    meta: {
      title: "Heaven's Fruit - Original Breeder Seeds"
    }
  },
  {
    path: "/galeria",
    name: "Gallery",
    component: GalleryPage,
    meta: {
      title: 'Galería'
    }
  },
  {
    path: "/formulario",
    name: "ContactForm",
    component: ContactForm,
    meta: {
      title: 'Contacto'
    }
  },
  {
    path: "/producto/:id",
    name: "ProductDetails",
    component: ProductDetails,
    meta: {
      title: 'Genética'
    }
  },
  {
    path: "/productos/",
    name: "ProductList",
    component: ProductList,
    meta: {
      title: 'Catálogo de semillas'
    }
  },
  {
    path: "/carrito/",
    name: "ShoppingCart",
    component: ShoppingCart,
    meta: {
      title: 'Carrito de compras'
    }
  },
  {
    path: "/blog",
    name: "Blog",
    component: BlogList,
    meta: {
      title: 'Blog'
    }
  },
  {
    path: "/blog/:slug",
    name: "BlogPostDetail",
    component: BlogPostDetail,
    meta: {
      title: 'Blog'
    }
  },
  {
    path: "/panel",
    component: PanelLayout,
    meta: { requiresAuth: true, panel: true },
    children: [
      { path: "", redirect: "/configuracion" },
      { path: "/admin", name: "AdminArea", redirect: "/admin/productos" },
      { path: "/configuracion", name: "AccountSettings", component: AccountSettings, props: { defaultSection: 'settings' }, meta: { section: 'settings' } },
      { path: "/configuracion/tienda", name: "AccountStoreSettings", component: AccountSettings, props: { defaultSection: 'store' }, meta: { section: 'store' } },
      { path: "/configuracion/notificaciones", name: "AccountNotifications", component: AccountSettings, props: { defaultSection: 'notifications' }, meta: { section: 'notifications' } },
      { path: "/admin/productos", name: "AdminProductList", component: AdminProductList, meta: { section: 'products' } },
      { path: "/admin/productos/nuevo", name: "ProductForm", component: ProductForm, meta: { section: 'products', panelTitle: 'Nuevo producto' } },
      { path: "/admin/productos/editar/:productId", name: "ProductEdit", component: ProductForm, meta: { section: 'products', panelTitle: 'Editar producto' } },
//       { path: "/admin/pedidos", name: "AdminOrderList", component: AdminOrderList, meta: { section: 'orders' } },
//       { path: "/admin/pedidos/:orderId", name: "AdminOrderDetails", component: AdminOrderDetails, meta: { section: 'orders', panelTitle: 'Detalle del pedido' } },
      { path: "/admin/usuarios", name: "UserList", component: UserList, meta: { section: 'users' } },
      { path: "/admin/usuarios/:id", name: "UserDetail", component: UserDetail, meta: { section: 'users', panelTitle: 'Detalle del usuario' } },
//       { path: "/admin/garantias", name: "AdminWarrantyClaims", component: AdminWarrantyClaims, meta: { section: 'warranty' } },
//       { path: "/admin/bancos", name: "AdminBankList", component: AdminBankList, meta: { section: 'banks' } },
//       { path: "/admin/marcas", name: "BrandList", redirect: "/admin/bancos" },
//       { path: "/admin/bancos/nuevo", name: "BankForm", component: BankForm, meta: { section: 'banks', panelTitle: 'Nuevo banco' } },
//       { path: "/admin/bancos/editar/:id", name: "BankEdit", component: BankForm, meta: { section: 'banks', panelTitle: 'Editar banco' } },
//       { path: "/admin/actividad", name: "ActivityLog", component: ActivityPage, meta: { section: 'activity' } },
      { path: "/admin/blog", alias: "/configuracion/blog", name: "AdminBlogList", component: AdminBlogList, meta: { section: 'blog' } },
      { path: "/admin/blog/nuevo", name: "BlogPostCreate", component: BlogPostEditor, meta: { section: 'blog', panelTitle: 'Nueva publicación' } },
      { path: "/admin/blog/editar/:id", name: "BlogPostEdit", component: BlogPostEditor, meta: { section: 'blog', panelTitle: 'Editar publicación' } },
      { path: "/configuracion/galeria", alias: "/admin/galeria", name: "AccountGallerySettings", component: () => import("@/components/GalleryManager.vue"), meta: { section: 'gallery' } },
      { path: "/configuracion/puntos-de-venta", alias: "/admin/puntos-de-venta", name: "AccountResellersSettings", component: () => import("@/components/ResellersManager.vue"), meta: { section: 'stores' } },
      { path: "/configuracion/mensajes", name: "AccountMessagesSettings", component: () => import("@/components/MessagesManager.vue"), meta: { section: 'messages', requiresAdmin: true, title: 'Mensajes · Panel' } },
      { path: "/configuracion/membresias", name: "AccountMembershipsSettings", component: () => import("@/components/MembershipManager.vue"), meta: { section: 'memberships', requiresAdmin: true, title: 'Membresías · Panel' } },
    ].map(record => ({
      ...record,
      meta: {
        ...record.meta,
        requiresAdmin: record.meta?.requiresAdmin || !!findPanelSection(record.meta?.section)?.admin,
      },
    })),
  },
  {
    path: "/login",
    name: "LoginForm",
    component: LoginForm,
    meta: { redirectIfAuth: true, title: 'Iniciar sesión' }
  },
  {
    path: "/registro",
    name: "RegisterForm",
    component: RegisterForm,
    meta: { redirectIfAuth: true, title: 'Crear cuenta' }
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/"
  }
];

const ensureBootstrap = (() => {
  let bootstrapPromise;
  return () => {
    if (!bootstrapPromise) {
      bootstrapPromise = import('bootstrap').then((module) => {
        if (typeof window !== 'undefined') {
          window.bootstrap = module;
        }
        return module;
      });
    }
    return bootstrapPromise;
  };
})();

/* Título de la pestaña según la ruta destino:
   - meta.title explícito gana siempre;
   - en el panel se arma con la etiqueta de la sección (panelSections) o el
     panelTitle de las páginas de detalle;
   - el nombre de la marca lo agrega setPageTitle(). */
function resolvePageTitle(to) {
  const meta = to.meta || {};

  if (meta.title) return meta.title;

  if (meta.panel) {
    const section = findPanelSection(meta.section);
    return `${meta.panelTitle || section?.label || 'Panel'} · Panel`;
  }

  return '';
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from) {
    // Salto a una sección con hash (p. ej. #puntos-de-venta): lo maneja la
    // página, porque la sección puede estar dentro de un montaje diferido.
    if (to.hash) {
      return false
    }

    // Al cambiar de página la cortina ya tapa la pantalla: el scroll al tope
    // se hace suave y recién después se deja ver la página nueva.
    if (deberiaAnimar(to, from)) {
      return { top: 0, behavior: 'smooth' }
    }

    return { top: 0 }
  },
});

/* Cortina de transición. Va registrada ANTES del guard de auth para que la
   pantalla ya esté tapada cuando la ruta cambia: así no se ve ni el salto de
   scroll de la página anterior ni el contenido viejo. */
router.beforeEach(async (to, from) => {
  // Salto a sección: sin cortina (el scroll suave lo hace la página destino).
  if (to.hash) return

  if (!deberiaAnimar(to, from)) return

  await taparPantalla()
});

router.afterEach(() => {
  // Ya tapada: scroll suave al tope y recién ahí sale la cortina.
  destaparPantalla()
});

/* Título de la pestaña: el de la sección destino. Las páginas con título
   dinámico (nombre de la genética, título de la nota) lo pisan al cargar. */
router.afterEach((to) => {
  setPageTitle(resolvePageTitle(to));
});

router.onError(() => {
  // Si la navegación falla, la cortina no puede quedar tapando el sitio.
  resetearCortina()
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.panel) {
    await ensureBootstrap();
  }

  const isAuthenticated = !!localStorage.getItem('accessToken');
  
  // Redirigir si ya está autenticado e intenta acceder a login
  if (to.meta.redirectIfAuth && isAuthenticated) {
    return next('/configuracion');
  }

  // Verificar si la ruta requiere autenticación
  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      // Guardar la ruta intentada para redirigir después del login
      localStorage.setItem('intendedRoute', to.fullPath);
      return next({
        name: 'LoginForm',
        query: { redirect: to.fullPath }
      });
    }

    // Verificar si la ruta requiere permisos de admin
    if (to.meta.requiresAdmin) {
      try {
        // Verificar permisos desde el backend
        const hasAdmin = await hasAdminPermission();
        if (!hasAdmin) {
          console.warn('Acceso denegado: Usuario no tiene permisos de administrador');
          return next('/configuracion');
        }
      } catch (error) {
        console.error('Error verificando permisos de admin:', error);
        // Si hay error de autenticación, redirigir a login
        if (error.response?.status === 401) {
          logout();
          return next({
            name: 'LoginForm',
            query: { redirect: to.fullPath }
          });
        }
        // Si hay otro error, redirigir a cuenta
        return next('/configuracion');
      }
    }
  }

  // Preserve old bookmarked section links while keeping the route as the only state.
  if (to.path === '/configuracion' && to.query.section) {
    const legacySections = { settings: '/configuracion', store: '/configuracion/tienda', notifications: '/configuracion/notificaciones', gallery: '/configuracion/galeria', resellers: '/configuracion/puntos-de-venta', blog: '/admin/blog' };
    const path = legacySections[to.query.section];
    const query = { ...to.query };
    delete query.section;
    return next({ path: path || '/configuracion', query, replace: true });
  }

  next();
});

window.addEventListener('auth:unauthorized', () => {
  logout();

  if (router.currentRoute.value.name !== 'LoginForm') {
    router.push({
      name: 'LoginForm',
      query: { redirect: router.currentRoute.value.fullPath }
    });
  }
});

export default router;
